import {IconButton, Stack, Typography} from "@mui/material";
import React from "react";
import {ControlledBoop} from "../animation/Boop";


export const AnimatedIconButtonWithLabel = React.forwardRef((props, ref) => {
    const {label, children, ...other} = props;
    const [activated, setActivated] = React.useState(false);
    return (
        <IconButton ref={ref} {...other} onMouseEnter={() => setActivated(true)}>
            <Stack justifyContent="center" alignItems="center">
                <ControlledBoop
                    rotation={45}
                    triggered={activated}
                    triggerHandler={setActivated}
                >
                    {children}
                </ControlledBoop>
                <Typography variant="caption">{label}</Typography>
            </Stack>
        </IconButton>
    );
});

export const IconButtonWithLabel = React.forwardRef((props, ref) => {
    const {label, children, ...other} = props;

    return (
        <IconButton ref={ref} {...other}>
            <Stack justifyContent="center" alignItems="center">
                {children}
                <Typography variant="caption">{label}</Typography>
            </Stack>
        </IconButton>
    );
});
